module.exports = __webpack_public_path__ + "static/en-4-354a983e103137fa8f258829e0724a05.png";